module.exports = __webpack_public_path__ + "5695a645cc6ebf37fabae1f032866195.svg";